export default [{
	path: 'roles',
	name: 'Role',
	component: resolve => require(['@/views/Role/index.vue'], resolve),
	meta: {
		title: '角色列表',
		name: 'Role',
	}
}];


// WEBPACK FOOTER //
// ./src/router/modules/role.route.js